import { z } from "zod";
import { EInvoiceStatus } from "../createInvoice/createInvoice.schema";

const BULK_STATUS_MAX = 500;

/** Invoice IDs may be 32-char hex (no hyphens) or standard UUID format. */
const invoiceIdSchema = z.union([
  z.string().regex(/^[a-f0-9]{32}$/i),
  z.string().uuid(),
  z.string().min(1),
]);

export const bulkUpdateInvoiceStatusRequestSchema = z.object({
  companyID: z.string().min(1),
  status: z.enum([
    EInvoiceStatus.APPROVED,
    EInvoiceStatus.DRAFT,
    EInvoiceStatus.CANCELLED,
    EInvoiceStatus.UNCOLLECTIBLE,
    EInvoiceStatus.SENT,
    EInvoiceStatus.PAID,
  ]),
  invoiceIDs: z.array(invoiceIdSchema).max(BULK_STATUS_MAX).optional(),
  /** When using filter (select all), IDs to exclude from the bulk update. */
  excludeIds: z.array(invoiceIdSchema).max(BULK_STATUS_MAX).optional(),
  /** When using filter, only update invoices whose current status is in this list (e.g. [PAID] for revert to unpaid). */
  onlyStatuses: z.array(z.string()).optional(),
  /** For status PAID: when to mark as paid (ISO date string). */
  marked_paid_at: z.string().optional(),
  /** For status PAID: payment method. */
  marked_paid_payment_method: z.string().optional(),
  search: z.string().optional(),
  statusFilter: z.string().optional(),
  payment_status: z.string().optional(),
  invoiceDateFrom: z.string().optional(),
  invoiceDateTo: z.string().optional(),
  dueDateFrom: z.string().optional(),
  dueDateTo: z.string().optional(),
});

export type TBulkUpdateInvoiceStatusRequest = z.infer<
  typeof bulkUpdateInvoiceStatusRequestSchema
>;

export const bulkUpdateInvoiceStatusResponseSchema = z.object({
  updated: z.number(),
});

export type TBulkUpdateInvoiceStatusResponse = z.infer<
  typeof bulkUpdateInvoiceStatusResponseSchema
>;
